import type { IPriceImprovementBlotterRequest } from 'apiConnector/blotters/priceImprovementBlotter';
import type { StringFileResponse } from 'models/FileResponse';
import { connect } from 'react-redux';
import type { Observable } from 'rxjs';
import type { ActivityFilter, DateFilter } from 'state/blotters/common/blotter.model';
import {
  priceImprovementBlotterAdvancedFiltersToggled,
  priceImprovementBlotterFilterChanged,
} from 'state/blotters/priceImprovement/priceImprovementBlotter.action';
import { priceImprovementBlotter } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export type FilterProps = FilterOwnProps & FilterStateProps & FilterDispatchProps;

type FilterOwnProps = {
  fetchCSV: (params: IPriceImprovementBlotterRequest) => Observable<StringFileResponse>;
};

interface FilterStateProps {
  quickSearchTerm?: string;
  dateFilter: DateFilter;
  activityFilter: ActivityFilter;
  statusFilter?: string;
  loading: boolean;
  error: boolean;
  advancedFilters: boolean;
  startDate?: string;
  endDate?: string;
  totalItems?: number;
  requestParams: IPriceImprovementBlotterRequest;
}

interface FilterDispatchProps {
  onDateFilterChanged(value: DateFilter): void;
  onActivityFilterChanged(value: ActivityFilter): void;
  onStatusFilterChanged(value?: string): void;
  onQuickSearchTermChanged(value?: string): void;
  onAdvancedFilterToggled(): void;
  onStartDateFilterChanged(date: Nullable<string>): void;
  onEndDateFilterChanged(date: Nullable<string>): void;
}

export const mapStateToProps = (state: AppState): FilterStateProps => {
  const { quickSearchTerm, dateFilter, activityFilter, statusFilter, advancedFilters, startDate, endDate } =
    priceImprovementBlotter.getFilters(state.blotters.priceImprovement);
  const loading = priceImprovementBlotter.getPriceImprovementBlotterLoading(state);
  const error = priceImprovementBlotter.getPriceImprovementBlotterError(state);
  const requestParams = priceImprovementBlotter.getBlotterRequest(state);
  const { totalItems } = priceImprovementBlotter.getPaginationInfo(state);
  return {
    quickSearchTerm,
    dateFilter,
    activityFilter,
    statusFilter,
    advancedFilters,
    startDate,
    endDate,
    loading,
    error,
    totalItems,
    requestParams,
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): FilterDispatchProps => ({
  onDateFilterChanged(dateFilter) {
    dispatch(priceImprovementBlotterFilterChanged('dateFilter', dateFilter));
  },
  onActivityFilterChanged(activity) {
    dispatch(priceImprovementBlotterFilterChanged('activityFilter', activity));
  },
  onStatusFilterChanged(status) {
    dispatch(priceImprovementBlotterFilterChanged('statusFilter', status));
  },
  onQuickSearchTermChanged(value) {
    dispatch(priceImprovementBlotterFilterChanged('quickSearchTerm', value));
  },
  onAdvancedFilterToggled() {
    dispatch(priceImprovementBlotterAdvancedFiltersToggled());
  },
  onStartDateFilterChanged(date) {
    if (date) {
      dispatch(priceImprovementBlotterFilterChanged('startDate', date));
    }
  },
  onEndDateFilterChanged(date) {
    if (date) {
      dispatch(priceImprovementBlotterFilterChanged('endDate', date));
    }
  },
});

export const connectFilterComponent = connect(mapStateToProps, mapDispatchToProps);
